import { API_URL } from '../../config'

async function request(rootState, path, method = 'GET', body, key) {
  const response = await fetch(`${API_URL}/arca${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json', Authorization: rootState.token,
      ...(key ? { 'Idempotency-Key': key } : {})
    },
    ...(body ? { body: JSON.stringify(body) } : {})
  })
  const result = await response.json()
  if (!response.ok || result.exito !== 1) {
    const error = new Error(result.message || 'No fue posible completar la operación ARCA.')
    error.code = result.code
    throw error
  }
  return result.data
}

export default {
  namespaced: true,
  actions: {
    status: ({ rootState }) => request(rootState, '/status'),
    lookup: ({ rootState }, cuit) => request(rootState, '/taxpayer', 'POST', { cuit }),
    catalogs: ({ rootState }, type) => request(rootState, `/catalogs?type=${type}`),
    issue: ({ rootState }, { invoice, key }) => request(rootState, '/invoices', 'POST', invoice, key),
    reconcile: ({ rootState }, key) => request(rootState, '/invoices/reconcile', 'POST', {}, key)
  }
}
